module.exports = __webpack_public_path__ + "static/img/Tom-Weaver.1b6e184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Weaver.jpg
// module id = 8vUd
// module chunks = 0